// @flow
import * as React from 'react';
import CopyableTestCardNumber from './CopyableTestCardNumber';
import IntegrationCheckerScenario from './IntegrationCheckerScenario';
import type {IntegrationCheckersDataIntegrationCheckerScenarioResult} from '../../generatedTypes';
import {getResult} from './AcceptACardPaymentScenarios';

// For each country, the first number is the succeeded case, the second is the failure case
// and the third is the disputed succeeded payment case.
export const countryList = {
  Austria: [
    'AT611904300234573201',
    'AT861904300235473202',
    'AT591904300235473203',
  ],
  Belgium: ['BE62510007547061', 'BE68539007547034', 'BE08510007547063'],
  Denmark: ['DK5000400440116243', 'DK8003450003179681', 'DK9300400440116245'],
  Estonia: [
    'EE382200221020145689',
    'EE762200221020145680',
    'EE492200221020145681',
  ],
  Finland: ['FI2112345600000785', 'FI9112345600000786', 'FI6412345600000787'],
  France: [
    'FR1420041010050500013M02606',
    'FR8420041010050500013M02607',
    'FR5720041010050500013M02608',
  ],
  Germany: [
    'DE89370400440532013000',
    'DE62370400440532013001',
    'DE35370400440532013002',
  ],
  Ireland: [
    'IE29AIBK93115212345678',
    'IE02AIBK93115212345679',
    'IE51AIBK93115212345670',
  ],
  Italy: [
    'IT40S0542811101000000123456',
    'IT60X0542811101000000123456',
    'IT83S0542811101000000123458',
  ],
  Lithuania: [
    'LT121000011101001000',
    'LT821000011101001001',
    'LT551000011101001002',
  ],
  Luxembourg: [
    'LU280019400644750000',
    'LU980019400644750001',
    'LU710019400644750002',
  ],
  Netherlands: [
    'NL39RABO0300065264',
    'NL91ABNA0417164300',
    'NL82RABO0300065266',
  ],
  Norway: ['NO9386011117947', 'NO6686011117948', 'NO3986011117949'],
  Portugal: [
    'PT50000201231234567890154',
    'PT23000201231234567890155',
    'PT93000201231234567890156',
  ],
  Spain: [
    'ES0700120345030000067890',
    'ES9121000418450200051332',
    'ES5000120345030000067892',
  ],
  Sweden: [
    'SE3550000000054910000003',
    'SE0850000000054910000004',
    'SE7850000000054910000005',
  ],
  'United Kingdom': [
    'GB82WEST12345698765432',
    'GB55WEST12345698765433',
    'GB28WEST12345698765434',
  ],
};

type Props = {
  country: string,
  results: Array<IntegrationCheckersDataIntegrationCheckerScenarioResult>,
  dashboardUrl: string,
};

const AcceptASEPADebitPaymentScenarios = (props: Props) => {
  const {results, country, dashboardUrl} = props;
  const currentCountry = country.length ? country : 'Austria';
  const accountNumbers = countryList[currentCountry];
  return (
    <React.Fragment>
      <IntegrationCheckerScenario
        title="Your integration handles successful SEPA Debit payments."
        testCardNumber={
          <CopyableTestCardNumber cardNumber={accountNumbers[0]} />
        }
        dashboardUrl={dashboardUrl}
        result={getResult(
          'sepa_debit_accept_a_payment_payment_succeeds',
          results,
        )}
      />
      <IntegrationCheckerScenario
        result={getResult('sepa_debit_accept_a_payment_payment_fails', results)}
        title="Your integration handles asynchronous payment failures."
        testCardNumber={
          <CopyableTestCardNumber cardNumber={accountNumbers[1]} />
        }
        dashboardUrl={dashboardUrl}
      />
      <IntegrationCheckerScenario
        result={getResult(
          'sepa_debit_accept_a_payment_payment_disputed',
          results,
        )}
        title="Your integration handles disputes created after a successful payment."
        testCardNumber={
          <CopyableTestCardNumber cardNumber={accountNumbers[2]} />
        }
        dashboardUrl={dashboardUrl}
      />{' '}
    </React.Fragment>
  );
};

export default AcceptASEPADebitPaymentScenarios;
